import { useContext } from 'react';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';

import {
  createCatalogMetricsContextV2,
  createCatalogMetricsEmptyContext,
} from './CatalogMetrics.type';

export function useCatalogMetricsContext<
  TMetrics extends { currency: string | null },
>() {
  const isConsignorMasterView = useUserHasConsignorMasterUI();

  return useContext(
    isConsignorMasterView
      ? createCatalogMetricsEmptyContext<TMetrics>()
      : createCatalogMetricsContextV2<TMetrics>()
  );
}
